import {
    takeLatest,
    put,
} from 'redux-saga/effects'

import {
    resetMTA,
} from '../actions'

function* resetMTATrigger() {
    yield put(resetMTA())
}

export const mtaSaga = [
    takeLatest('ADD_MTA_FULFILLED', resetMTATrigger),
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/mta.ts